import { FC } from 'react';
import { UtilityText } from 'components/Typography';
import { RecipientStatus, RestrictedRecipientStatus } from 'store/recipients/types';

const DETAIL_TEXT: Record<RestrictedRecipientStatus, string> = {
  [RecipientStatus.LOST]:
    'Candidate lost their election and is no longer eligible to receive donations.',
  [RecipientStatus.WITHDREW]:
    'Candidate withdrew from their race and is no longer eligible to receive donations.',
  [RecipientStatus.IN_SESSION_RESTRICTED]:
    'Candidate is currently in session and cannot raise funds due to state regulations.',
};

interface Props {
  recipientStatus: RestrictedRecipientStatus;
}

export const RestrictedCandidateDetail: FC<Props> = ({ recipientStatus }) => (
  <div className="candidate-detail-row wrapped">
    <UtilityText>Details:</UtilityText>
    <UtilityText>{DETAIL_TEXT[recipientStatus]}</UtilityText>
  </div>
);
